<template>
  <main class="content page">
    <div v-if="page" :class="!loading ? '' : 'loading'">
      <hero id="show" :page="page"></hero>
      <awards v-if="page.awards" :awards="page.awards"></awards>
      <press v-if="page.awards" id="press" :items="page.awards.items"></press>
      <contact id="contact" v-if="page.contact" :contact="page.contact"></contact>
      <the-team id="team" v-if="page.team" :team="page.team"></the-team>
      <shop-module></shop-module>
    </div>
  </main>
</template>

<script>
import Hero from '@/components/common/Hero'
import Awards from '@/components/about/Awards'
import Press from '@/components/about/Press'
import Contact from '@/components/about/Contact'
import TheTeam from '@/components/about/TheTeam'
import ShopModule from '@/components/common/ShopModule'

export default {
  name: 'about',
  data () {
    return {
      loading: true,
      page: null
    }
  },
  mounted () {
    this.fetchPost()
  },
  methods: {
    fetchPost () {
      let vm = this
      vm.$axios.get('/posts', {
        params: {
          slug: 'about'
        }
      })
      .then((response) => {
        vm.page = response.data
        process.nextTick(() => {
          vm.loading = false
          if (vm.$route.hash) vm.scrollToAnchor()
        })
      })
      .catch((err) => {
        vm.loading = false
        console.log(err)
      })
    },
    scrollToAnchor () {
      let id = this.$route.hash.replace('#', '')
      process.nextTick(() => {
        document.getElementById(id).scrollIntoView()
      })
    }
  },
  components: {
    Hero,
    Awards,
    Press,
    Contact,
    TheTeam,
    ShopModule
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// About.vue?74185e3f